
/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-24 17:53:56
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-24 17:58:47
 */
export default [
    {
        path: '/report-to-push',
        name: 'report-to-push',
        meta: {
            name: '报表推送',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/reportToPush')
    },
]
